export const faqData = [
  {
    id: 1,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Services",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "25 Sep 2023, 01:22 pm",
    status: "Active",
    Action: "",
    key: "1"
  },
  {
    id: 2,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Advertising",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "29 Sep 2023, 08:12 am",
    status: "Active",
    Action: "",
    key: "2"
  },
  {
    id: 3,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Services",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "02 Oct 2023, 02:32 pm",
    status: "Active",
    Action: "",
    key: "3"
  },
  {
    id: 4,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Services",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "11 Oct 2023, 02:32 pm",
    status: "Active",
    Action: "",
    key: "4"
  },
  {
    id: 5,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Media",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "04 Nov 2023, 04:22 pm",
    status: "Active",
    Action: "",
    key: "5"
  },
  {
    id: 6,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Content Marketing",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "16 Nov 2023, 10:51 pm",
    status: "Active",
    Action: "",
    key: "6"
  },
  {
    id: 7,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Health Care",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "25 Nov 2023, 03:43 pm",
    status: "Active",
    Action: "",
    key: "7"
  },
  {
    id: 8,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Services",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "07 Dec 2023, 11:22 am",
    status: "Active",
    Action: "",
    key: "8"
  },
  {
    id: 9,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Social Marketing",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "15 Dec 2023, 08:17 am",
    status: "Active",
    Action: "",
    key: "9"
  },
  {
    id: 10,
    si_no: "",
    select: "",
    questions: "How can I book a service",
    category: "Media",
    answers: "Lorem ipsum dolor amet, adipiscing elit",
    created_at: "29 Dec 2023, 01:22 pm",
    status: "Active",
    Action: "",
    key: "10"
  },
];
